import { render, staticRenderFns } from "./ModuleText.vue?vue&type=template&id=053557d0"
import script from "./ModuleText.vue?vue&type=script&lang=js"
export * from "./ModuleText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports